<template>
    <div>
        <template v-if="roles">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Roles</h1>
                <router-link v-if="crud_role" to="/manageAddRole" class="btn btn-primary float-right">Add Role</router-link>
            </div>
            <table id="rolesTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Company Name</th>
                        <th>Created</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-if="roles == false">
            Sorry this page is not accessable!
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                crud_role : null,
                roles : null
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('manage_roles|crud_roles').then(result => {
                this.crud_role = result.crud_roles;
                this.roles = result.manage_roles;
            }).then(result => {
                if(this.roles == true){
                    this.listRoles();
                }
            });
        },
        methods: {
            listRoles: function(){
                var that = this;
                $('#rolesTable').DataTable({
                    processing: true,
                    serverSide: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    ajax: {
                        "url": "api/listRolesAdmin",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'company_name'},
                        {data: 'created_at'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/manageEditRole/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" >Edit</a>';
                        }, visible: that.crud_role},
                    ],
                    "order": [[ 0, "desc" ]],
                });
            }
        },
        created() {
        }
    }
</script>
